import ReactDOM from 'react-dom'
import Page from 'containers/pages/MyCourses.jsx'
import 'styles/main.scss'
import 'styles/global.scss'

ReactDOM.render(<Page />, document.getElementById('private_body'))
